export default {
  labels: {
    open: 'Afficher les articles',
    collapse: 'Fermer les articles',
    in_stock: 'En stock',
    out_of_stock: 'Rupture de stock',
  },
  list: {
    name: 'Article du menu',
    price: 'Prix',
    is_available: 'EN STOCK / RUPTURE',
  },
};
